import { Component, Input, SimpleChanges } from '@angular/core';

/**
 * Generated class for the SubmenuSelectionComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'submenu-selection',
  templateUrl: 'submenu-selection.html'
})
export class SubmenuSelectionComponent {

  text: string;

  @Input() subParts: number;
  @Input() flowQtt: any;
  @Input() flowSequence: any;

  constructor() {
  }

  ngOnInit(){
    this.init();
  }
  ngOnChanges(changes:SimpleChanges){
    console.log(this.subParts);
    console.log(this.flowSequence);
  }

  init(){
    console.log(this.subParts);
    console.log(this.flowSequence);
  }
}



// WEBPACK FOOTER //
// ./src/components/submenu-selection/submenu-selection.ts